// src/components/StampListModal.js
import { useTranslation } from 'react-i18next';
import StampItem from './StampItem';
import '../styles/StampListModal.css';

export default function StampListModal({ isOpen, onClose, stamps, onStampClick }) {
  const { t } = useTranslation();
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) onClose?.();
  };

  const handleItemClick = (stamp) => {
    onClose?.();
    onStampClick?.(stamp);
  };

  // ヘッダーは従来どおり（UIを変えない）
  const HEADER_BADGE = '/images/stamp/stampspot-icon.svg';

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="stamp-list-modal">
        {/* ===== Header（従来の見た目そのまま） ===== */}
        <div className="stamp-modal-header" style={{ textAlign: 'center', padding: '28px 20px 12px' }}>
          <div
            className="stamp-header-icon"
            aria-hidden
            style={{
              width: 96,
              height: 96,
              borderRadius: '50%',
              margin: '0 auto 14px',
              display: 'grid',
              placeItems: 'center',
              background: 'transparent',
            }}
          >
            <img
              src={HEADER_BADGE}
              alt=""
              style={{ width: '100%', height: '100%', display: 'block' }}
              onError={(e) => (e.currentTarget.style.display = 'none')}
            />
          </div>

          <h2
            className="stamp-modal-title"
            style={{
              margin: '0 0 10px',
              fontSize: 22,
              lineHeight: 1.4,
              fontWeight: 800,
            }}
          >
            {t('stampList.title', 'デジタルスタンプラリー')}<br />
            {t('stampList.titleSpot', 'スポット一覧')}
          </h2>

          <p
            className="stamp-modal-description"
            style={{
              margin: 0,
              color: '#6b7280',
              fontSize: 14,
              lineHeight: 1.7,
            }}
          >
            {t('stampList.description', 'クリアするとスポットのアイコンが')}
            <br />
            {t('stampList.description2', '緑に変わります。')}
          </p>
        </div>

        {/* ===== Grid（UIそのまま） ===== */}
        <div className="stamp-list-content" style={{ paddingTop: 16 }}>
          <div
            className="stamp-grid"
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: 20,
            }}
          >
            {stamps.map((stamp) => (
              <StampItem
                key={stamp.id}
                stamp={stamp}                     // ← category / completed / name を含む
                onClick={() => handleItemClick(stamp)}
              />
            ))}
          </div>
        </div>

        {/* ===== Footer ===== */}
        <button className="close-button" onClick={onClose}>
          {t('map.buttons.close', '閉じる')}
        </button>
      </div>
    </div>
  );
}
